<template>
  <div>
    <div>
      <p class="ma-0 font-weight-medium">
        Lote mínimo
      </p>
      <p class="ma-0 mt-n1">
        <template v-if="detalhamento_categoria.unidade_compra !== '-'">
          {{ Helpers.formatarValorComCasas(detalhamento_categoria.lote_minimo, 4) }}
          <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
        </template>
        <template v-else>-</template>
      </p>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      width="500"
      content-class="bra-20"
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-card-title>
            <span>Lote Mínimo</span>
          <v-spacer />
          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <SysCategoriaMPPA
            v-model="categorias_selecionadas"
            label="Categorias onde a edição será feita"
            :qtde_visivel_selecionados="1"
            outlined
            clearable
            multiple
            :error-messages="getMensagensValidacao('categorias_selecionadas')"
          />

          <TextFieldFormatadorDeValor
            v-model="lote_minimo"
            outlined
            label="Lote mínimo"
            :suffix="categoria.idunidade_medida"
            :error-messages="getMensagensValidacao('lote_minimo')"
            @focus="$event.target.select()"
            @keyup.enter="alterarValorLoteMinimo()"
          />
        </v-card-text>

        <v-card-actions class="mt-n6">
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="alterarValorLoteMinimo()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import { required, minValue } from "vuelidate/lib/validators";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import { alterarLoteMinimo } from "@/api/compras/MateriaPrima";
import { logout } from '@/helpers';
import SysCategoriaMPPA from "@/components/utils/crud/SysCategoriaMPPAAutocomplete";

export default {
  name: 'LoteMinimo',
  components: {
    SysCategoriaMPPA,
    TextFieldFormatadorDeValor
  },
  props: {
    detalhamento_categoria: Object,
    categoria: Object
  },
  data () {
    return {
      dialog_ativo: false,
      categorias_selecionadas: [],
      lote_minimo: 0,
    }
  },
  validations: {
    categorias_selecionadas: {required},
    lote_minimo: {
      required,
      minValue: minValue(0.0001),
    }
  },
  watch: {
    dialog_ativo(valor) {
      if(valor) {
        this.lote_minimo = this.detalhamento_categoria.lote_minimo;
        this.categorias_selecionadas = [this.categoria.idcategoria];
      } else {
        setTimeout(() => {
          this.lote_minimo = 0;
          this.categorias_selecionadas = [];
          this.$v.$reset();
        }, 1000);
      }
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarGridCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'compraMateriaPrima/callbackAtualizarDetalhesCategoria',
    })
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v[campo].$dirty) return [];

      if ((this.$v[campo].$params.required !== undefined) && !this.$v[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v[campo].$params.minValue !== undefined) && !this.$v[campo].minValue) {
        return  ["Informe um valor maior."];
      }

      return [];
    },
    alterarValorLoteMinimo() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const params = {
        categorias: this.categorias_selecionadas,
        lote_minimo: parseFloat(this.lote_minimo)
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        alterarLoteMinimo(params)
          .then(() => {
            this.dialog_ativo = false;
            this.$emit("novo-lote-minimo", this.lote_minimo);
            this.callbackAtualizarGridCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style>

</style>
